<template>
  <div class="fertilizer">
    <div class="box">Ikke tøft å være død.</div>
    <div class="updated">24 XI 2003</div>
  </div>
</template>

<script>
export default {
  name: "ikketoft"
};
</script>

<style scoped>
.fertilizer {
  background: #fff;
}

.box {
  font-size: 18px;
  color: #bbb;
  font-weight: bold;
  margin-top: -20px;
}

.updated {
  color: #c0c0c0;
}
</style>
